import { useCreateOrderAdjustment } from 'api-hooks/order-adjustment';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { NavigationProps } from 'types';

import OrderAdjustmentForm from './components/form';

export type OrderAdjustmentCreateParams = null;

export default function OrderAdjustmentCreate(
  props: NavigationProps<NavigationRoutes.OrderAdjustmentCreate>,
) {
  const { mutateAsync, error } = useCreateOrderAdjustment();

  const onResolve = useApprovalableEdit('order-adjustments');

  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
        </>
      )}
      <OrderAdjustmentForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
